import React, { useState, memo } from "react";
import { Button } from "@mui/material";
import moment from "moment-jalaali";
import ExcelJS from "exceljs";
import {Loading} from "../../../components";

const MarketerOperationMapExport = ({ marketer, entities }) => {
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("OperationReport");

            // Define columns
            worksheet.columns = [
                { header: "عنوان", key: "title", width: 40 },
                { header: "مقدار", key: "counter", width: 20 }
            ];


            entities.forEach((item) => {
                worksheet.addRow({
                    title: item.title || '-',
                    counter: item.counter ?? 0
                });
            });


            worksheet.getRow(1).eachCell((cell) => {
                cell.font = { bold: true, size: 14 };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFCCEEFF' }
                };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });


            worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                if (rowNumber > 1) {
                    row.eachCell((cell) => {
                        cell.font = { size: 12 };
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    });
                }
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `marketer_operation_map_${marketer}_${moment().unix()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting operation map:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                onClick={fetchData}
                disabled={loading}
            >
                خروجی گزارش رشد
            </Button>
            {loading && <Loading />}
        </>
    );
};

export default memo(MarketerOperationMapExport);
